export default {"src":"/_next/static/media/getting-started-beach.colour.3ecd2412.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};